// extracted by mini-css-extract-plugin
export var customSelect = "GdkMiddlewareDropdown-module__custom-select___1Jc1v";
export var customSelectWrapper = "GdkMiddlewareDropdown-module__custom-select-wrapper___ZN4Po";
export var disabled = "GdkMiddlewareDropdown-module__disabled___TBndG";
export var emailError = "GdkMiddlewareDropdown-module__emailError___WiShE";
export var selectDropdownLabel = "GdkMiddlewareDropdown-module__selectDropdownLabel___uVfMD";
export var textBox = "GdkMiddlewareDropdown-module__text-box___tvHKd";
export var textBoxWrapper = "GdkMiddlewareDropdown-module__text-box-wrapper___Xk-A6";
export var unauthorizedSellersList = "GdkMiddlewareDropdown-module__unauthorizedSellersList___tu2lx";